<template>
	<v-row justify="space-between">
		<v-col cols="5" class="hidden-sm-and-down">
			<v-row justify="space-between">
				<v-col class="text--secondary title text-left">
					Agregar Personas
				</v-col>
			</v-row>
			<v-row>
				<v-col class="px-12">
					<v-img src="@/assets/PERSONAS-1.png"></v-img>
				</v-col>
			</v-row>
		</v-col>
		<v-col cols="12" md="7">
			<v-card flat color="transparent">
				<v-card-title v-if="!hasNameFromProps" class="text--secondary subtitle-2">
					Invita a una persona
				</v-card-title>
				<v-card-text v-if="!hasNameFromProps">
					<v-text-field
						flat
						v-model.trim="email"
						:loading="loading"
						solo
						dense
						filled
						outlined
						label="Correo electronico"
						type="email"
						hint="Ejemplo: correo@correo.com"
					>
						<template v-slot:append>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn
										small
										:disabled="loading"
										color="primary"
										@click.stop="submit"
									>
										<v-icon left v-on="on">mdi-email-send</v-icon>
										invitar
									</v-btn>
								</template>
								Enviar invitación
							</v-tooltip>
						</template>
					</v-text-field>
					<v-divider></v-divider>
				</v-card-text>
				<v-card-title class="text--secondary subtitle-2">
					Agrega a una persona
				</v-card-title>
				<v-card-text>
					<v-text-field
						v-model="$v.person.firstName.$model"
						solo
						flat
						dense
						filled
						outlined
						autocomplete="off"
						:loading="loadingCreate"
						label="Nombre de la persona"
						:error-messages="nameErrors"
						@input="$v.person.firstName.$touch()"
						@blur="$v.$reset()"
					>
						<template v-slot:append>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn
										small
										:disabled="loadingCreate"
										color="success"
										@click.stop="save"
									>
										<v-icon left v-on="on">mdi-plus</v-icon>
										Agregar
									</v-btn>
								</template>
								Agregar persona
							</v-tooltip>
						</template>
					</v-text-field>
					<div v-if="comparePerson" class="text-left caption warning--text">
						Existe una persona con este nombre
					</div>
				</v-card-text>
				<!-- <v-card-title class="text--secondary subtitle-2">
					Agrega personas con CSV
				</v-card-title>
				<v-card-text>
					<v-file-input
						class="mt-2"
						v-model="fileCSV"
						label="Seleccione un documento"
						hint="*requerido"
						persistent-hint
						outlined
						dense
						:loading="loadingCSV"
					>
						<template v-slot:append>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn
										small
										:disabled="loadingCSV || !fileCSV"
										color="success"
										@click.stop="submitPersonCSV"
									>
										<v-icon left v-on="on">mdi-plus</v-icon>
										Subir CSV
									</v-btn>
								</template>
								Subir CSV
							</v-tooltip>
						</template>
					</v-file-input>
					<ul class="text-left red--text">
						<li v-for="(element, i) in errors" :key="i">
							ERROR Linea {{ element.index + 1 }}: {{ element.error }}
						</li>
					</ul>
				</v-card-text> -->
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
	name: 'SelectorCreate',
	mixins: [validationMixin],
	props: {
		editable: {
			type: Boolean,
			default: false,
		},
		setFilfter: {
			type: Function,
			default: () => null,
		},
		close: {
			type: Function,
			default: () => null,
		},
		namePerson: {
			type: String,
			default: '',
		},
		setPerson: {
			type: Function,
			default: () => null,
		},
	},
	data() {
		return {
			email: '',
			person: { firstName: '' },
			loadingCreate: false,
			loading: false,
			hasNameFromProps: false,
			fileCSV: undefined,
			loadingCSV: false,
			errors: [],
		};
	},
	computed: {
		nameErrors() {
			const errors = [];
			if (!this.$v.person.firstName.$dirty) return errors;
			!this.$v.person.firstName.required && errors.push('El nombre es querido');
			return errors;
		},
		comparePerson() {
			if (this.persons.length && this.person.firstName)
				return this.persons.some(
					item =>
						item.firstName.toLowerCase() === this.person.firstName.toLowerCase() ||
						(item.lastName && item.lastName.toLowerCase()) ===
							this.person.firstName.toLowerCase()
				);
			return false;
		},
		...mapGetters({
			persons: 'Person/persons',
		}),
	},
	mounted() {
		if (this.namePerson) {
			this.hasNameFromProps = true;
			this.$v.person.firstName.$model = this.namePerson;
		}
	},
	methods: {
		async submit() {
			this.loading = true;
			this.email = this.email.toLowerCase();
			if (this.persons.some(person => person.email === this.email)) {
				this.loading = false;
				this.email = '';
				return this.snackbar({
					content: `Ya se encuentra entre tus contactos`,
					color: 'info',
				});
			}
			await this.newRequest({
				email: this.email,
				name: `${this.userProfile.name} ${this.userProfile.lastName &&
					this.userProfile.lastName}`,
				company: this.userProfile.company,
				editable: this.editable ? 'editable' : '',
				idCompany: this.userProfile._id,
			});
			this.email = '';
			this.loading = false;
		},
		async save() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.loadingCreate = true;
				const response = await this.createPerson({
					firstName: this.person.firstName,
					editable: !this.persons.length || this.editable ? 'editable' : '',
					isUser: false,
				});
				this.person.firstName = '';
				this.setFilfter(response.firstName);
				this.$v.$reset();
				if (this.hasNameFromProps) this.setPerson(response._id);
				this.close();
				this.loadingCreate = false;
			}
		},
		async submitPersonCSV() {
			if (!this.file) {
				const payload = new FormData();
				payload.append('csv', this.fileCSV);
				const response = await this.createPersonCSV({ payload });
				if (response.notCreatedPersons) {
					this.notCreatedPersons = response.notCreatedPersons;
				}
				if (response.errors) {
					this.errors = response.errors;
				}
				this.file = undefined;
			}
		},
		...mapActions({
			newRequest: 'Person/newRequest',
			createPerson: 'Person/createPerson',
			updateLodging: 'Lodging/updateLodging',
			createPersonCSV: 'Person/createPersonCSV',
		}),
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
		}),
	},
	validations: {
		person: {
			firstName: { required },
		},
	},
	watch: {
		namePerson(newValue) {
			if (newValue) {
				this.hasNameFromProps = true;
				this.$v.person.firstName.$model = newValue;
			}
		},
	},
};
</script>
